import axios from 'axios';

// Create axios instance for API calls
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

// Add request interceptor to add headers
apiClient.interceptors.request.use(
  (config) => {
    // Default headers
    config.headers['Content-Type'] = 'application/json';
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    
    // Add dev mode header if we're in development environment
    if (process.env.REACT_APP_ENV === 'development') {
      config.headers['X-Dev-Mode'] = 'true';
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;